import { SELECT_FAVOURITE, SET_WARNING } from "../constants/actions";

const initState = {
  id: null,
  name: "",
  odds: {
    minOdds: null,
    maxOdds: null,
    isDecimal: true,
  },
  markets: [],
  warning: "",
};

const favourites = (state = initState, action) => {
  // new reducer to handle favourites for the bubble journey
  switch (action.type) {
    case "UPDATE_FAVOURITE_NAME": {
      return {
        ...state,
        name: action.payload,
      };
    }
    case "ADD_FAVOURITE_MARKET_SELECTION": {
      if (Array.isArray(action.payload.selection)) {
        return {
          ...state,
          [action.payload.filter]: [
            ...new Set([
              ...state[action.payload.filter],
              ...action.payload.selection.map((option) => option.type),
            ]),
          ],
        };
      }

      return {
        ...state,
        [action.payload.filter]: [
          ...new Set([
            ...state[action.payload.filter],
            action.payload.selection.type,
          ]),
        ],
      };
    }

    case "REMOVE_MARKET_FROM_FAVOURITES": {
      return {
        ...state,
        markets: state.markets.filter(
          (market) => market !== action.payload.selection.type
        ),
      };
    }

    case "REMOVE_MARKET_GROUP_FROM_FAVOURITES": {
      const selectionMarketTypes = action.payload.selection.map(
        (market) => market.type
      );
      return {
        ...state,
        [action.payload.filter]: state[action.payload.filter].filter(
          (market) => !selectionMarketTypes.includes(market)
        ),
      };
    }

    case "ADD_FAVOURITE_ODDS_SELECTION": {
      return {
        ...state,
        odds: action.payload.selection,
      };
    }

    case "REMOVE_FAVOURITE_ODDS_SELECTION": {
      return {
        ...state,
        odds: initState.odds,
      };
    }

    case "EDIT_FAVOURITE": {
      return {
        ...state,
        ...action.payload,
      };
    }

    case SET_WARNING: {
      return {
        ...state,
        warning: action.payload,
      };
    }

    case "RESET_FAVOURITE_OPTIONS": {
      return {
        ...initState,
        id: state.id,
      };
    }

    case "CLEAR_ALL_FAVOURITES_SELECTIONS": {
      return {
        ...initState,
      };
    }

    case SELECT_FAVOURITE: {
      return {
        ...state,
        id: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default favourites;
